import { useEffect, useRef, useState } from 'react'
import Constants from '../../../app/utils/constants'
import highlightImage from '../../../assets/images/industrypage/highlight.webp'

const CaseHighlight = () => {
  const { title, body, bodySecondary } =
    Constants.healthcareCaseHighlight

  const ref = useRef<HTMLDivElement | null>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting)
      },
      { threshold: 0.3 }
    )

    if (ref.current) observer.observe(ref.current)

    return () => observer.disconnect()
  }, [])

  return (
    <section
      ref={ref}
      className="mx-auto w-full max-w-[90%]"
    >

      {/* 🔥 ANIMATION CSS */}
      <style>{`
  .scale-base {
    transition: all 0.9s cubic-bezier(0.22, 1, 0.36, 1); /* 🔥 smoother */
  }

  .scale-enter {
    transform: scale(0.85);
    opacity: 0;
  }

  .scale-show {
    transform: scale(1);
    opacity: 1;
  }
`}</style>

      {/* Title */}
      <h2 className="mb-6 text-center font-rajdhani text-2xl font-semibold text-white sm:text-3xl md:text-4xl lg:text-5xl">
        {title}
      </h2>

      {/* Banner */}
      <div
  className={`
    relative w-full overflow-hidden rounded-[30px]
    h-[230px] sm:h-[260px] md:h-[320px] lg:h-[350px] xl:h-[400px] 2xl:h-[420px]
    scale-base
    ${visible ? 'scale-show' : 'scale-enter'}
  `}
>

        {/* Background Image */}
        <img
          src={highlightImage}
          alt={title}
          className="absolute inset-0 h-full w-full object-cover object-center"
        />

        {/* Text Content */}
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-1 px-6 sm:gap-4 md:gap-5 md:px-10 lg:px-16 xl:px-24">
          <p className="max-w-[90%] text-center font-gilroy-medium leading-tight md:leading-relaxed text-white text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl">
            {body}
          </p>

          <p className="max-w-[90%] text-center font-gilroy-medium leading-tight md:leading-relaxed text-white text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl">
            {bodySecondary}
          </p>
        </div>

      </div>
    </section>
  )
}

export default CaseHighlight